import * as moment from "moment";
import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from "../restricted-account-object/restricted-account-object.model";
import { AuditValue } from "./audit-value.model";

interface IAuditlogArgs extends IRestrictedAccountObjectArgs {
    entityName?: string;
    entityId?: string;
    wasCreated?: boolean;
    wasDeleted?: boolean;
    auditValues?: Array<AuditValue>;
}

const defaults = () => ({
    created: moment().toISOString(),
    entityName: "",
    entityId: "",
    wasCreated: false,
    wasDeleted: false,
    auditValues: []
});

export class AuditLog extends RestrictedAccountObject {
    entityName: string;
    entityId: string;
    wasCreated: boolean;
    wasDeleted: boolean;
    auditValues: Array<AuditValue>;

    constructor(data?: IAuditlogArgs) {
        super({...defaults, ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/audit-log/audit-log.model.ts